(function (XHR) {
  "use strict";
  var open = XHR.prototype.open;
  var send = XHR.prototype.send;
  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };
  XHR.prototype.send = function (data) {
    var url = this._url;
    if (
      url &&
      url.toLowerCase() ===
        "https://w9elbf89hbax876h5u7892cf-fast.searchtap.net/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);

      console.log(body);
      body.filter += ' AND NOT tags="preowned rolex watch"';
      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);

window.sq = window.sq || {};
window.sparqCurrencyFormatter = (number) => {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    .format(number)
    .replace(/\D00(?=\D*$)/, "");
};

window.sq.onData = function (data) {
  // console.log(data);
  data.results.forEach((x) => {
    const firstVariant = x.variants.filter((x) => x.position === 1)[0];
    x.price = firstVariant.price;
    x.compare_at_price = firstVariant.compare_at_price;
  });

  return data;
};

window.sq.onItemComplete = function (el, item) {
  let priceElement = el.querySelector(".sq-price ");

  if (priceElement) {
    let formattedPrice = window.sparqCurrencyFormatter(
      parseFloat(priceElement.innerHTML.replace("$", "").replace(",", ""))
    );
    priceElement.innerHTML = formattedPrice;
  }
};

window.sq.onComplete = function (el, opts) {
  const dropdownTemplate = el.querySelector(
    ".sparq-popup.sparq-dropdown-container"
  );
  const noResults = el.querySelector(".sparq-no-results");
  if (opts.UIType === "dropdown") {
    if (noResults && dropdownTemplate) {
      dropdownTemplate.classList.add("sparq-hide");
    } else {
      return el;
    }
  }
};

window.onload = function(){
  console.log(document.querySelector(".search-form .btn--primary[type='submit']"));
  document.querySelector(".search-form .btn--primary[type='submit']").addEventListener("click",(e)=>{
    e.preventDefault();
    const inputElement = document.querySelector("[name='q']");
    const enterKeyEvent = new KeyboardEvent("keydown", {
      key: "Enter",
      code: "Enter",
      keyCode: 13,
      which: 13,
      bubbles: true,
      cancelable: true,
    });

  inputElement.dispatchEvent(enterKeyEvent);

  })
}
